/**
 * IframeResizerController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Utility.IframeResizerController = function () {
  $('.js-dynamic-iframe').iFrameResize();
};
